/**
 * @GestionalePD Sidebar navigation UI
 */
import SvgColor from '../../../components/svg-color';

// Custom icon style
const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

// Navigation properties
const navConfig = [
  {
    title: 'dashboard',
    path: '/user/dashboard',
    icon: icon('ic_dashboard'),
  },
  {
    title: 'profilo',
    path: '/user/profile',
    icon: icon('ic_user'),
  },
  // {
  //   title: 'tessera',
  //   path: '/user/card',
  //   icon: icon('ic_card'),
  // },
  {
    title: 'organizzazione',
    path: '/user/organization',
    icon: icon('ic_organization'),
  },
  // {
  //   title: 'badge',
  //   path: '/user/badge',
  //   icon: icon('ic_badge'),
  // },
  {
    title: 'eventi',
    path: '/user/events',
    icon: icon('ic_calendar'),
  },
  // Newsletter nascosta dal menu per il primo rilascio in produzione (riattivare togliendo il commento).
  // {
  //   title: 'newsletter',
  //   path: '/user/newsletter',
  //   icon: icon('ic_newsletter'),
  // },
  // {
  //   title: 'calendario',
  //   path: '/user/calendar',
  //   icon: icon('ic_calendar'),
  // },
  // {
  //   title: 'questionari',
  //   path: '/user/surveys',
  //   icon: icon('ic_vote'),
  // },
  // {
  //   title: 'documenti',
  //   path: '/user/documents',
  //   icon: icon('ic_documents'),
  // },
];

export default navConfig;
